import { environment } from '@environment';

export const ID_ENDPOINT = environment.ID_ENDPOINT;
export const ADMIN_ENDPOINT = environment.ADMIN_ENDPOINT;
export const BILLING_ENABLED = environment.billingEnabled;

/** The onboarding kill-switch: flip to `true` to bring the whole gate (the glued 8-step `/onboarding`
 *  funnel and the album-less project resume) back. Off → no user is ever redirected into a wizard. */
export const ONBOARDING_ENABLED: boolean = false;
